module.exports = __webpack_public_path__ + "static/img/faq3.e40c36c.png";